import * as React from 'react';
export const IcCoolingHeating = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M14.44 8.32A1 1 0 0015.8 8l.5-.86a1.001 1.001 0 10-1.73-1l-.5.86a1 1 0 00.37 1.32zm4.5 3.27h-1a1 1 0 000 2h1a1 1 0 000-2zM12 7a1 1 0 001-1V4a1 1 0 00-2 0v2a1 1 0 001 1zm4.17 2.33a1 1 0 00.1.76 1 1 0 00.99.486 1 1 0 00.37-.126l1.74-1a1 1 0 00-1-1.73l-1.74 1a1 1 0 00-.46.61zM12 18a1 1 0 00-1 1v2a1 1 0 102 0v-2a1 1 0 00-1-1zm7.37-2.28l-1.74-1a1 1 0 00-1 1.73l1.74 1a1 1 0 001-1.73zm-3.57 1.63a1 1 0 00-1.36-.35 1 1 0 00-.37 1.37l.5.86a1 1 0 101.73-1l-.5-.88zm.14-4.76A4 4 0 0013 8.76v7.65a4 4 0 002.94-3.82zM11 10.27L8.53 8.84 7.9 6.51a1 1 0 00-1.22-.71A1 1 0 006 7l.11.4-1.37-.8a1.003 1.003 0 00-1 1.74l1.37.79-.4.11a1.008 1.008 0 00.26 2h.26l2.33-.63L10 12l-2.47 1.43-2.33-.63a1 1 0 10-.52 1.93l.4.11-1.37.79a1.003 1.003 0 101 1.74l1.37-.8L6 17a1 1 0 00.71 1.23c.086.01.174.01.26 0a1 1 0 001-.74l.63-2.33 2.4-1.43v-3.46z'
      fill='currentColor'
    />
  </svg>
);
